(ns teamoesterreich.admin-mode.crowdtasker.event-detail-form
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.data.event :as s-events]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.util.markdown :refer [md]]))





(defn get-base [!actual-event disabled]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !data (r/cursor !st [:data])
        !orgId (r/cursor !st [:data :crowdtaskerEvent-orgId])]
    (fn []
      (let [has-edit-right false
            changed? (fn [key]
                       ;(log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!actual-event key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get @!actual-event key))))
            has-changes? (or
                           (changed? :crowdtaskerEvent-name)
                           (changed? :crowdtaskerEvent-locationName)
                           (changed? :crowdtaskerEvent-acceptableUntil)
                           (changed? :crowdtaskerEvent-timeFrom)
                           (changed? :crowdtaskerEvent-timeTo)
                           (changed? :crowdtaskerEvent-orgId)
                           (changed? :crowdtaskerEvent-allowWaitingList)
                           (changed? :crowdtaskerEvent-maxMember)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))
            from-date (h-date/parse-service-date! (or (:crowdtaskerEvent-timeFrom @!data) (:crowdtaskerEvent-timeFrom @!actual-event)))
            to-date (h-date/parse-service-date! (or (:crowdtaskerEvent-timeTo @!data) (:crowdtaskerEvent-timeTo @!actual-event)))

            fromError (and from-date to-date (h-date/date>? from-date to-date))
            toError (and from-date to-date (h-date/date>? from-date to-date))
            ]

        (when (nil? @!orgId) (reset! !orgId (or (:crowdtaskerEvent-orgId @!actual-event) (first (d-rights/get-rights-orgId-filter d-rights/CROWDTASKER)))))

        [mui/card
         (log/debug "rerender form " (:crowdtaskerEvent-orgId @!actual-event) (clj->js @!orgId) (clj->js @!actual-event))

         [mui/card-header {:title "Online Einsatz Details"}]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    3
            :style      {:margin "0"}
            }


           [mui/grid
            {:item  true
             :md    6
             :xs    12
             :style {:backgroundColor (if (changed? :crowdtaskerEvent-orgId) "#ffd6d2" "#ffffff")}
             }
            [(org-selector/get-org-selector !orgId (d-rights/get-rights-orgId-filter d-rights/CROWDTASKER) {:border "" :readonly (not @!edit-mode)})]

            ]

           [mui/grid
            {:item true
             :md   12
             :xs   12
             }]

           [mui/grid
            {:container false :item true
             :md 6
             :xs 12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-name) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-name @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-name (h/event-value e)))
                             :label        "Einsatz Name"}]
            ]
           [mui/grid
            {:container false :item true
             :md 6
             :xs 12
             :style {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerEvent-locationName) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerEvent-locationName @!actual-event))
                             :onChange     (fn [e] (change-fn :crowdtaskerEvent-locationName (h/event-value e)))
                             :label        "Einsatz Ort"}]
            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerEvent-timeFrom) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :label           "Einsatz Beginn"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :crowdtaskerEvent-timeFrom date)))
                             :defaultValue    (h/from-timezone-iso (:crowdtaskerEvent-timeFrom @!actual-event))
                             :error fromError
                             :helperText (if fromError "ungültig (muss vor Einsatz Ende sein)" "")
                             }]
            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerEvent-timeTo) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :label           "Einsatz Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (h/to-timezone-iso date)]
                                                  (change-fn :crowdtaskerEvent-timeTo date)))
                             :defaultValue    (h/from-timezone-iso (:crowdtaskerEvent-timeTo @!actual-event))
                             :error fromError
                             :helperText (if fromError "ungültig (muss nach Einsatz Beginn)" "")
                             ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake]])}
                             }]
            ]
           ]
          [mui/card-actions
           (when (and (not @!edit-mode) (not disabled))
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten"])

           (when (and (not @!edit-mode) disabled)
             [mui/button {
                          :variant "outlined"
                          :style {:color "orange"}
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten (superuser)"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [keyboard-arrow-left])
                          :onClick   #(reset! !edit-mode false)

                          } "Abbrechen"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [save])
                          :disabled  (or (not has-changes?) fromError toError )
                          :onClick (fn []
                                     (s-events/>event-save (:crowdtaskerEvent-uuid @!actual-event)
                                                           (merge @!data
                                                                  [:crowdtaskerEvent-orgId (if (and @!orgId (not= "" @!orgId))  @!orgId (first (d-rights/get-rights-orgId-filter d-rights/CROWDTASKER)) )])
                                                           (fn [data]
                                                             (reset! !actual-event data))))
                          } "Speichern" ])

           ]
          ]

         ]))))

(defn get-description [!actual-event disabled]              ;; push/SMS
  (let [!state (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !show-send-me (r/cursor !state [:show-send-me])
        !su-edit (r/cursor !state [:su-edit])]
    (fn []
      (let [save-fn (fn [text]
                      (s-events/>event-save (:crowdtaskerEvent-uuid @!actual-event) {:crowdtaskerEvent-description text}
                                            (fn [data]
                                              (reset! !su-edit false)
                                              (reset! !actual-event data))))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         [:h3 "Einsatzbeschreibung (angezeigt vor der Annahme)"]
         [are-you-sure-modal/are-you-sure-modal !show-send-me
          "Möchtest du diese Alarmierung testweise an dich senden ?" "Senden"
          (fn [] (s-events/>event-send-test-alarm (:crowdtaskerEvent-uuid @!actual-event) (:tom-id @!actual-user)))]
         (if (and disabled (not @!su-edit))
           [:div {:style {:border "1px dotted darkgrey" :paddingBottom "10px"}}

            [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!actual-event :crowdtaskerEvent-description) ""))}
                   :className "editor-preview-widget"
                   :style {:width "45%" :margin-left "5%" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" }}]
            [:br]
            (when (and disabled)
              [mui/button {
                           :variant "outlined"
                           :style {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])]
           [(edit-md-card/get-it (get @!actual-event :crowdtaskerEvent-description) save-fn (str backend/BASE_URL "/media-upload") "Einsatzbeschreibung (angezeigt vor der Annahme)"
                                 "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#"
                                 nil on-cancel-fn
                                 )])]
        ))))

(defn get-briefing [!actual-event disabled]
  (let [!state (r/atom {:show-send-me false})
        !actual-user (r/cursor store/app-state [:actual-user])
        !show-send-me (r/cursor !state [:show-send-me])
        !su-edit (r/cursor !state [:su-edit])]
    (fn []
      (let [has-edit-right false
            save-fn (fn [text]
                      (s-events/>event-save (:crowdtaskerEvent-uuid @!actual-event) {:crowdtaskerEvent-briefing text}
                                            (fn [data]
                                              (reset! !su-edit false)
                                              (reset! !actual-event data))))
            on-cancel-fn #(reset! !su-edit false)]
        [:div
         [:h3 "Einsatzbefehl (angezeigt nach der Annahme)"]
         [are-you-sure-modal/are-you-sure-modal !show-send-me
          "Möchtest du dieses Einsatzbefehl Email testweise an dich senden ?" "Senden"
          (fn [] (s-events/>event-send-test-briefing (:crowdtaskerEvent-uuid @!actual-event) (:tom-id @!actual-user)))]
         (if (and disabled (not @!su-edit))
           [:div {:style {:border "1px dotted darkgrey" :paddingBottom "10px"}}

            [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!actual-event :crowdtaskerEvent-briefing) ""))}
                   :className "editor-preview-widget"
                   :style {:width "45%" :margin-left "5%" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" }}]
            [:br]
            (when (and disabled)
              [mui/button {
                           :variant "outlined"
                           :style {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !su-edit true)
                           } "Bearbeiten (superuser)"])]
           [(edit-md-card/get-it (get @!actual-event :crowdtaskerEvent-briefing) save-fn (str backend/BASE_URL "/media-upload") "Einsatzbefehl (angezeigt nach der Annahme)"
                                 "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#"
                                 nil on-cancel-fn
                                 )]
           )]
        ))))


(defn get-it [!actual-event disabled]
  [mui/card-content {}
   [(get-base !actual-event disabled)]
   [:br]
   [(get-description !actual-event disabled)]
   [:br]
   [(get-briefing !actual-event disabled)]
   ])